import { render, staticRenderFns } from "./PreferencesModuleComponent.vue?vue&type=template&id=17ecc278&scoped=true"
import script from "./PreferencesModuleComponent.vue?vue&type=script&lang=js"
export * from "./PreferencesModuleComponent.vue?vue&type=script&lang=js"
import style0 from "./PreferencesModuleComponent.vue?vue&type=style&index=0&id=17ecc278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ecc278",
  null
  
)

export default component.exports